import React from "react";
import CollectorImg from "../../assets/collectors.png";

const Collector = () => {
  return (
    <div className="my-20">
      <div className="block lg:flex justify-between items-center">
        <div>
          <img src={CollectorImg} className="lg:w-4/5 " alt="" />
        </div>
        <div className="w-full mt-5 shadow-xl p-10 lg:w-2/5">
          <p>For Collectors</p>
          <p className="text-3xl font-bold my-3">
            Get exclusive access to our holder benefits
          </p>
          <p>
            As a PREMINT Collector Pass holder, you will get access to an
            evolving collector dashboard and features to keep you on top of the
            hottest mints.
          </p>
          <button className="bg-[color:var(--purple-color)] py-3 px-6 text-white mt-3 rounded-full">
            Learn More &nbsp; <i class="fa-solid fa-arrow-right-long"></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Collector;
